import React from "react";
import LineChart from "../../Chart/LineChart";

function PowerNlPowerCharts({ charts, printedChart, type }) {
  return (
    <div>
      <div className="powerPageCharts">
        <LineChart
          yAxisTitle="€/MWh"
          data={charts}
          colors={[
            "#004474",
            "#65C800",
            "#B28D2F",
            "#EC6707",
            "#73CCF4",
            "#1B2C56",
            "#75B951",
          ]}
          showLegend
          type={type}
        />
      </div>
      <div className="powerPrintedCharts">
        <LineChart
          yAxisTitle="€/MWh"
          data={printedChart}
          colors={[
            "#004474",
            "#65C800",
            "#B28D2F",
            "#EC6707",
            "#73CCF4",
            "#1B2C56",
            "#75B951",
          ]}
          showLegend
          height={250}
        />
      </div>
    </div>
  );
}

export default PowerNlPowerCharts;
